import React from 'react';

import { Box, Stack } from '@mui/material';

import { useDashboardCVAdminData, useDashboardPrintView } from 'src/hooks/dashboard';
import { DEFAULT_DASHBOARD_CV_ADMIN_CONTEXT } from 'src/providers/DashboardCVAdminProvider';

import { DashboardFilterCVAdmin } from './components';
import { NOW } from './components/constants';
import { DashboardFinancialDataAccess } from './DashboardFinancialDataAccess';

export const DashboardFinancialCVAdmin: React.FC = () => {
  const { isPrintView } = useDashboardPrintView();
  const {
    setDate,
    setEmployers,
    setPeos,
    setRevenueByVerificationTypeStartDate,
    setRevenueByVerificationTypeEndDate,
    setRevenueDistributionsStartDate,
    setRevenueDistributionsEndDate,
  } = useDashboardCVAdminData();

  React.useEffect(() => {
    if (!isPrintView) {
      setEmployers(DEFAULT_DASHBOARD_CV_ADMIN_CONTEXT.employers);
      setDate(NOW);
      setPeos(DEFAULT_DASHBOARD_CV_ADMIN_CONTEXT.peos);
      setRevenueByVerificationTypeStartDate(
        DEFAULT_DASHBOARD_CV_ADMIN_CONTEXT.revenueByVerificationTypeStartDate,
      );
      setRevenueByVerificationTypeEndDate(
        DEFAULT_DASHBOARD_CV_ADMIN_CONTEXT.revenueByVerificationTypeEndDate,
      );
      setRevenueDistributionsStartDate(
        DEFAULT_DASHBOARD_CV_ADMIN_CONTEXT.revenueDistributionsStartDate,
      );
      setRevenueDistributionsEndDate(
        DEFAULT_DASHBOARD_CV_ADMIN_CONTEXT.revenueDistributionsEndDate,
      );
    }
  }, [
    isPrintView,
    setDate,
    setEmployers,
    setPeos,
    setRevenueByVerificationTypeEndDate,
    setRevenueByVerificationTypeStartDate,
    setRevenueDistributionsEndDate,
    setRevenueDistributionsStartDate,
  ]);

  return (
    <Box pt={4} padding={isPrintView ? 4 : 'none'}>
      <Stack gap={3}>
        <DashboardFilterCVAdmin />
        <DashboardFinancialDataAccess />
      </Stack>
    </Box>
  );
};
